/**
 * VideoCanvasNode
 *
 * Canvas visualisation uses the videoregistry to set canvas and size, the renders are registered by the 
 * specific connected source endpoints, eg HydraEndpoint -> HydraRenderer
 */

import { BaseNode } from '@nodes/BaseNode';
import type { NodeDef } from '@runtime/IRuntime';
import { internals, params } from '@/nodes/TypedEndpoints';

/**
 * Interface for nodes that can render to a canvas context.
 */
export interface ICanvasRenderer {
  render(dt?: number): void;
  setSize(width: number, height: number): void;
  setCanvas(canvas: HTMLCanvasElement): void;
  getCanvas(): HTMLCanvasElement | null;
}

const endpoints = {
  ...params({
    bgColor: { dataType: 'color', value: { r: 0, g: 0, b: 0, a: 1 }, label: 'Background' },
  }),
  ...internals({
    videoIn: { isInput: true, dataType: 'video' },
  })
};

class VideoCanvasNode extends BaseNode<typeof endpoints>  {}

export const videoCanvasNodeDef: NodeDef<VideoCanvasNode> = {
  type: 'Canvas',
  shortName: 'canvas',
  info: 'Canvas output for 2D video rendering. Connects to source endpoints for display.',
  category: 'output',
  endpoints,
  ctor: VideoCanvasNode
};
